define('mailsMailRightCollapsedAttachmentsView',[
  'module',
  'app',
  'backbone',
  'underscore',
  'marionette',
  'mailsMailRightCollapsedAttachmentView',
  'template!mailsMailRightCollapsedAttachmentsView'
], function (
  Module,
  App,
  Backbone,
  _,
  Marionette,
  AttachmentView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'attachments-view',
    childView: AttachmentView,
    childViewContainer: '.attachments',

    childViewOptions: function() {
      return {
        mailModel: this.model,
        mailSecId: this.options.mailSecId,
        // When set, image/PDF attachments open in an in-app preview modal
        // instead of a new browser tab (opt-in by the host view).
        preview: this.options.preview
      };
    }
  });
});
